export default "__VITE_ASSET__0DiCrpEJ__"